var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('letter-commitment',{attrs:{"type":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }